// Flatpickr defaults the time inputs to 12:00.
// For an empty date/time field, show the current time in the logged-in user's timezone
// (meta[name="timezone"]) instead, without writing any value into the field.

function pad(n) {
    return (n < 10 ? '0' : '') + n;
}

function userTimezoneNow() {
    let now = new Date(),
        timezone = $('meta[name="timezone"]').attr('content');

    if (timezone) {
        try {
            let parts = new Intl.DateTimeFormat('en-GB', {
                timeZone: timezone,
                hour: '2-digit',
                minute: '2-digit',
                hourCycle: 'h23'
            }).formatToParts(now);
            let hour = parseInt(parts.find(p => p.type === 'hour').value, 10) % 24,
                minute = parseInt(parts.find(p => p.type === 'minute').value, 10);

            return {hour: hour, minute: minute};
        } catch (e) {
            // invalid timezone, fall back to browser time
        }
    }

    return {hour: now.getHours(), minute: now.getMinutes()};
}

export function applyUserDefaultTime(selectedDates, dateStr, instance) {
    if (!instance.config.enableTime || instance.selectedDates.length > 0) {
        return;
    }

    let now = userTimezoneNow();
    instance.config.defaultHour = now.hour;
    instance.config.defaultMinute = now.minute;

    if (instance.hourElement && instance.minuteElement) {
        instance.hourElement.value = pad(now.hour);
        instance.minuteElement.value = pad(now.minute);
    }
}
